// src/services/careerService.js

import api from './api';

export const getCareers = async () => {
  try {
    const response = await api.get('/Careers');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCareerById = async (id) => {
  try {
    const response = await api.get(`/Careers/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCareer = async (career) => {
  // Use CreateCareerDTO structure
  try {
    const response = await api.post('/Careers', {
      position: career.position,
      description: career.description,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCareer = async (id, career) => {
  // Use UpdateCareerDTO structure
  try {
    const response = await api.put(`/Careers/${id}`, {
      position: career.position,
      description: career.description,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCareer = async (id) => {
  try {
    const response = await api.delete(`/Careers/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
